// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"385a9af2","298":"e3a4e043","453":"463c4245","888":"d21fa87e"}[chunkId] + ".chunk.js";
};